"use client";

import { Anchor } from "~/components/Anchor";
import { Navbar } from "~/components/Navbar/component";
import { PageHeader } from "~/components/PageHeader";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { MediaCitationsListPage } from "~/modules/media_citations/pages/list";
import { MediaCitation } from "~/modules/media_citations/types";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";

import type { JSX } from "react";

// // // //

export function CitationsView(props: {
    citations: MediaCitation[];
    title: string;
}): JSX.Element {
    const { citations, title } = props;

    return (
        <PageTrack route={Routes.citations}>
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.citations} user={user} />}
            </UserFetcher>
            <SidebarLayout pathname={Routes.citations}>
                <PageWrapper>
                    <PageHeader
                        title={title}
                        subtitle={
                            <>
                                Every published reference to RWA.xyz data,
                                searchable. Writing a report or story on
                                real-world asset tokenization? Contact{" "}
                                <Anchor
                                    href="mailto:team@rwa.xyz"
                                    variant="default"
                                    analyticsLabel="Citations Contact Email"
                                >
                                    team@rwa.xyz
                                </Anchor>{" "}
                                for data or assistance.
                            </>
                        }
                    />
                    <MediaCitationsListPage citations={citations} />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
